<div class="row">
  <div class="col-md-12 popin-container align-items justify-content-center">
    <div class="title text-center">
      <h1>Merci pour toutes ces informations !</h1><br>
      <h3>Votre demande à bien été prise en compte et le responsable en charge vous recontactera rapidement.</h3>
    </div>
  </div>
</div>
